import React from 'react';
import Modal from '../shared/Modal';
import { safeRender } from '../../helpers/util';
import { ACCOUNT_STATUSES } from '../../const.js';

class ChefAccountStatusModal extends React.Component {
  render() {
    const { chef, isOpen, closeModal, newStatus } = this.props;
    const setToDeactivate = newStatus === ACCOUNT_STATUSES.DEACTIVATED;
    const title = setToDeactivate
      ? 'Deactivate Account'
      : 'Set Account to Inactive';
    const body = setToDeactivate
      ? 'Are you sure you want to deactivate this account? This will remove all upcoming services for this chef.'
      : 'Are you sure you want to set this account to inactive?';

    const cancelBtnClass =
      'btn btn--full-width ' +
      (setToDeactivate ? 'btn--hollow-red-bright' : 'btn--hollow-yellow');
    const confirmlBtnClass =
      'btn btn--full-width ' +
      (setToDeactivate ? 'btn--solid-red' : 'btn--solid-gold');
    return (
      <Modal isOpen={isOpen} onRequestClose={closeModal}>
        <h2 className="h2 modal__heading">{title}</h2>
        <div className="form__row--spacer">
          <div className="modal__p">
            <p className="p">{body}</p>
          </div>
          <p className="p p--bold">Name</p>
          <p className="p">{safeRender('name', chef)}</p>
        </div>
        <div className="form__row">
          <div className="form__row-item--half">
            <div className={cancelBtnClass} onClick={closeModal}>
              Cancel
            </div>
          </div>
          <div className="form__row-item--half">
            <div
              className={confirmlBtnClass}
              onClick={() => this.props.changeAccountStatus(newStatus)}
            >
              {setToDeactivate ? 'Deactivate' : 'Set to Inactive'}
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
export default ChefAccountStatusModal;



// WEBPACK FOOTER //
// ./src/components/chef/ChefAccountStatusModal.js